import type {ComponentPropsWithoutRef, ComponentType} from 'react';
import React, {useRef} from 'react';
import {arrow, FloatingArrow} from '@floating-ui/react';

import type {FloatingContext} from '@floating-ui/react';
import type {Middleware} from '@floating-ui/dom';


export type ArrowComponent = ComponentType<{
    /**
     * $FlowIgnoreMe WHY: Floating UI has no Flow type definitions
     **/
    getContext: () => FloatingContext,
}>;

export type UseArrowProps = {
    enabled?: boolean,
    padding?: number,
    componentProps?: Partial<ComponentPropsWithoutRef<typeof FloatingArrow>>,
};

export type UseArrowReturnType = {
    height: number,
    /**
     * $FlowIgnoreMe WHY: Floating UI has no Flow type definitions
     **/
    middleware?: Middleware,
    Component: ArrowComponent,
};

export type UseArrow = (props?: UseArrowProps) => UseArrowReturnType;


export const useArrow: UseArrow = ({
    enabled,
    componentProps = {},
    padding = 6,
} = {}) => {
    const {
        height = 6,
        strokeWidth = 1,
    } = componentProps;
    const arrowRef = useRef(null);

    if (!enabled) {
        return {
            height: 0,
            Component: () => null,
        };
    }

    const middleware = arrow({
        padding,
        element: arrowRef,
    });

    return {
        height: height + strokeWidth,
        middleware,
        Component: props => (
            <FloatingArrow
                fill="white"
                stroke="#d8dde3"
                width={8}
                strokeWidth={strokeWidth}
                height={height}
                {...componentProps}
                ref={arrowRef}
                context={props.getContext()}
            />
        ),
    };
};
